/* =============================================================================
=    Check user account exist
============================================================================= */
import { gql } from '@apollo/client';

export default gql`
mutation isUserExist($email: String!) {
  isUserExist(email: $email)
}
`;
